import { checkOnline } from 'helpers/apiHelpers';
import { normalizeVersion, initializeOrangeBook, getLatestOBVersion } from './orangeBookService';

export let OrangeData = null;
export let OBLatestVersion = null;
export let APIVersion = null;

export function setOBLatestVersion(ver) {
    OBLatestVersion = ver;
}

export function setAPIVersion(ver) {
    APIVersion = ver;
}

export function setOrangeData(od) {
    OrangeData = od;
}

export async function compareOBVersions() {
  await initializeOrangeBook();

  if (!checkOnline()) return 0;     // offline equals the same

  const remoteVersion = normalizeVersion(
    await getLatestOBVersion()
  );

  const localVersion = normalizeVersion(
    OBLatestVersion
  );

  //console.log(localVersion, remoteVersion);
  if (remoteVersion.comparable > localVersion.comparable) {
    return 1;
  }

  if (remoteVersion.comparable < localVersion.comparable) {
    return -1;
  }

  return 0;
}

// ***********************************************
function requireOrangeBookData() {
  if (!Array.isArray(OrangeData)) {
    throw new Error(
      "Orange Book data has not been initialized. " +
      "Call initializeOrangeBook() first."
    );
  }

  return OrangeData;
}

export function findDrug(name, brand) {
    if (!name || !brand) return null;
    const uname = name.toUpperCase();
    const ubrand = brand.toUpperCase();
    //console.log('findDrug', uname, ubrand);

    let item = null;
    const oddata = requireOrangeBookData();
    for(var od of oddata) {
        if (od.ingredient === uname && od.trade_name === ubrand) {
            item = {
                'name': od.ingredient,
                'brand': od.trade_name,
                'type': od.type,
                'id': od.id.toString()
            };
            break;
        }
    }
    return (item);
}
export function findDrugNames(searchName) {
    if (!searchName) return [];
    const uname = searchName.toUpperCase();
    //console.log('findDrugNames', uname);
 
    let medNames = [];
    let genericNames = [];
    let tradeNames = [];
    //console.log('medNames', medNames);

    const od = requireOrangeBookData();
    od.forEach(od => {
        if (od.ingredient.startsWith(uname) && od.ingredient === od.trade_name && !genericNames.includes(od.ingredient)) {
            genericNames.push(od.ingredient);
            const item = {
                'name': od.ingredient,
                'generic': '',
                'class': 'G',
                'type': od.type,
                'id': od.id.toString()
            }
            medNames.push(item);
            //console.log('g-names', item);
        }
        if (od.trade_name.startsWith(uname) && !genericNames.includes(od.trade_name)) {
            tradeNames.push(od.trade_name);
            const item = {
                'name': od.trade_name,
                'generic': od.ingredient,
                'class': 'T',
                'type': od.type,
                'id': od.id.toString()
            }
            medNames.push(item);
            //console.log('t-names', item);
        }
    });

    //console.log('presort medNames', medNames);

    // medNames.sort((a, b) => {
    //     if (a.name < b.name) { return -1; }
    //     if (a.name > b.name) { return 1; }
    //     return 0;
    // });
    
    //console.log('return medNames', medNames);
    return medNames;
}

export function findBrandNames(searchName) {
    const name = searchName.toUpperCase();
    //console.log('findBrandNames', name);
    if (!name) return [];
    const uname = name.toUpperCase();
 
    const names = [];
    const tradeNames = [];
    const od = requireOrangeBookData();
    od.forEach(od => {
        if (od.ingredient === uname && od.trade_name !== uname && !tradeNames.includes(od.trade_name)) {
            tradeNames.push(od.trade_name);
            const item = {
                'name': od.trade_name,
                'class': 'T',
                'type': od.type,
                'id': od.id.toString()
            }
            names.push(item);
        }
    });
    //console.log('trade', names);

    names.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
    });
    
    return names;
}

export function getStrength(idString, form) {
    const id = parseInt(idString);
    if (!id) return [];

    const od = requireOrangeBookData();
    const item = od[id-1];
    //console.log('getStrength', idString, form, item);
    if (item.forms.length === 1) {
        return [...item.forms[0].dosage];
    };
    const uform = form.toUpperCase();
    var s = [];
    for (let i = 0; i < item.forms.length; ++i) {
        //console.log('each form', f);
        let f = item.forms[i];
        if (f.form === uform) {
            s = [...f.dosage];
            break;
        };
    };

    return s;
}

export function getForms(idString) {
    const forms = [];
    const id = parseInt(idString);
    if (!id) return forms;

    //console.log('getForms', idString, id);
    const od = requireOrangeBookData();
    const item = od[id-1];
    item.forms.forEach(f => {
        forms.push(f.form);
    })

    return forms;
}

// export function getForm(idString, form) {
//     const id = parseInt(idString);
//     //console.log('getForms', idString, id);
//     const od = requireOrangeBookData();
//     const item = od[id-1];
//     item.forms.forEach(f => {
//         if (f.form === form) return f.form;
//     })

//     return null;
// }

export function getForm(idString, form) {
  const id = Number.parseInt(idString, 10);

  if (!id || !form) {
    return null;
  }

  const od = requireOrangeBookData();
  const item = od[id - 1];

  if (!item?.forms) {
    return null;
  }

  const matchingForm = item.forms.find(
    entry => entry.form === form
  );

  return matchingForm?.form ?? null;
}
